ui-bank-search-webform {
  display: block;

  /* stylelint-disable */
  #wf_abschluss {
    text-align: center;

    ui-button,
    ui-paragraph {
      margin-top: 32px;
    }

    ui-richtext,
    ui-headline {
      margin-top: 24px;
    }

    ui-headline {
      display: flex;
      justify-content: center;
    }

    ui-icon {
      height: 54px;
      width: 54px;

      &::after {
        content: '1';
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: -3px;
        right: -3px;
        height: 25px;
        width: 25px;
        color: var(--ui-color-white);
        background-color: #d23a4a;
        border-radius: 100%;
      }
    }

    .final-screen__icon-container {
      display: flex;
      position: relative;
      justify-content: center;
      align-items: center;
      height: 80px;
      width: 80px;
      background-color: var(--ui-color-grey-100);
      border-radius: 100%;
      margin: 0 auto;

      @include breakpoint($desktop) {
        margin-top: 80px;
      }
    }
  }
  /* stylelint-enable */
}
